import createAction from '../services/create-action';
import sanitizeContent from '../services/sanitize-content';

export const UPDATE_COMMENT_REQUEST = 'comment/UPDATE_REQUEST';
export const UPDATE_COMMENT_SUCCESS = 'comment/UPDATE_SUCCESS';
export const UPDATE_COMMENT_FAILURE = 'comment/UPDATE_FAILURE';

export const updateCommentRequest = createAction(UPDATE_COMMENT_REQUEST);
export const updateCommentSuccess = createAction(UPDATE_COMMENT_SUCCESS);
export const updateCommentFailure = createAction(UPDATE_COMMENT_FAILURE);

export function updateComment(comment) {
  const { _id: commentId, postId, content } = comment;
  return (dispatch, getState, { request }) => {
    dispatch(updateCommentRequest());

    const promise = request.patch(`/_api/posts/${postId}/comments/${commentId}`, sanitizeContent({ content }));

    return promise
      .then(comment => dispatch(updateCommentSuccess(comment)))
      .catch(() => dispatch(updateCommentFailure()))
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/update-comment.js